export default __webpack_public_path__ + "static/media/3233 spice rack E side.367cf235.png";